import type { UseCaseTemplate } from "../types";

/**
 * 用途テンプレート。スマホUI・WebサイトLPなど、
 * 「何をどう書けばいいか」を省いてすぐ生成に入るための出発点。
 */
export function TemplatePicker({
  templates,
  compact,
  onApply,
}: {
  templates: UseCaseTemplate[];
  /** フォーム上部用の小さい表示 */
  compact?: boolean;
  onApply: (t: UseCaseTemplate) => void;
}) {
  if (compact) {
    return (
      <div className="flex flex-wrap gap-1.5">
        {templates.map((t) => (
          <button key={t.id} type="button" onClick={() => onApply(t)} className="chip" title={t.hint}>
            <span aria-hidden>{t.emoji}</span>
            {t.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="grid w-full max-w-2xl grid-cols-2 gap-2.5 sm:grid-cols-3">
      {templates.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onApply(t)}
          className="flex flex-col items-start gap-1 rounded-2xl border-2 border-slate-200 bg-white p-3.5 text-left transition hover:border-brand-300 hover:bg-brand-50/40"
        >
          <span className="text-[22px] leading-none" aria-hidden>
            {t.emoji}
          </span>
          <span className="mt-1 text-[13.5px] font-bold text-slate-700">{t.label}</span>
          <span className="text-[11.5px] leading-relaxed text-slate-400">{t.hint}</span>
        </button>
      ))}
    </div>
  );
}
